import { Platform, StyleSheet } from 'react-native';
import { widthInPercentage } from '../../../utils/appUtils';

export default StyleSheet.create({
  componentView: {
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 100
  },
  btnstyle: {
    position: Platform.OS === 'web' ? 'fixed' : 'absolute',
    bottom: 0,
    right: 0,
    left: 0,
    elevation: 15,
    backgroundColor: '#fff'
  },
  buttontext: {
    color: 'white'
  },
  buttontext_LDPI: {
    color: 'yellow'
  },
  buttontext_MDPI: {
    color: 'black'
  },
  buttontext_HDPI: {
    color: 'black'
  },
  buttontext_XHDPI: {
    color: 'black'
  },
  buttontext_XXHDPI: {
    color: 'black'
  },
  buttontext_XXXHDPI: {
    color: 'black'
  },
  moreButton: {
    width: '90%',
    height: 60,
    justifyContent: 'center',
    shadowOpacity: 2,
    shadowRadius: 3,
    borderRadius: 1,
    backgroundColor: '#ff6600'
  },
  cardLessButton: {
    width: '90%',
    height: 60,
    justifyContent: 'center',
    shadowOpacity: 2,
    shadowRadius: 3,
    borderRadius: 1,
    backgroundColor: '#101d6c'
  },
  prifletextvw: { marginLeft: widthInPercentage(1) },
  prifletextvw_LDPI: { marginLeft: widthInPercentage(2) },
  prifletextvw_HDPI: { marginLeft: widthInPercentage(2) },
  prifletextvw_MDPI: { marginLeft: widthInPercentage(2) },

  prifletextvw_XHDPI: { marginLeft: widthInPercentage(0) },
  prifletextvw_XXHDPI: { marginLeft: widthInPercentage(2) },
  ProfileserviceText: {
    textAlign: 'left',
    fontFamily: 'Mulish',
    fontWeight: '500',
    fontSize: 14,
    //color: '#894302',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#101d6c',
    //marginLeft:widthInPercentage(56)
  },
  // ProfileserviceText: {
  // marginRight:widthInPercentage(1)
  // },
  serviceText: {
    textAlign: 'left',
    fontFamily: 'Mulish',
    fontWeight: '500',
    fontSize: 14,
    color: '#894302',
    alignItems: 'center',
    justifyContent: 'center'
  },
  serviceText_LDPI: {
    fontWeight: '500',
    fontSize: 12,
    color: '#894302',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center'
  },
  serviceText_MDPI: {
    fontWeight: '500',
    fontSize: 14,
    color: '#894302',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    textAlign: 'center'
  },
  serviceText_HDPI: {
    fontWeight: '500',
    fontSize: 14,
    color: '#894302',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center'
  },
  serviceText_XXHDPI: {
    textAlign: 'left',
    fontWeight: '400',
    fontSize: 12,
    color: '#894302',
    alignItems: 'center',
    justifyContent: 'center'
  },
  serviceText_XHDPI: {
    fontWeight: '500',
    fontSize: 12,
    color: '#894302',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center'
  },
  newserviceText: {
    textAlign: 'center',
    fontFamily: 'Mulish',
    fontWeight: 'bold',
    fontSize: 18,
    color: '#fff'
  },
  serviceContent: {
    width: '100%',
    justifyContent: 'center',
    flexDirection: 'row',
    alignItems: 'center'
  },
  serviceContent_XXHDPI: {
    width: '100%',
    justifyContent: 'center',
    flexDirection: 'row',
    alignItems: 'center'
  },
  serviceContent_XHDPI: {
    width: '100%',
    justifyContent: 'center',
    flexDirection: 'row',
    alignItems: 'center'
  },
  serviceContent_HDPI: {
    width: '100%',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center'
  },
  serviceContent_MDPI: {
    width: '100%',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    alignSelf: 'center'
  },
  serviceContent_LDPI: {
    width: '100%',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    alignSelf: 'center'
  },
  cardLessButton_LDPI: {
    width: '90%',
    height: 60,
    marginBottom: '2%',
    justifyContent: 'center',
    shadowOpacity: 2,
    shadowRadius: 3,
    borderRadius: 1,
    backgroundColor: '#101d6c'
  },
  cardLessButton_HDPI: {
    width: '70%',
    height: 60,
    marginBottom: '2%',
    justifyContent: 'center',
    shadowOpacity: 2,
    shadowRadius: 3,
    borderRadius: 1,
    backgroundColor: '#101d6c'
  },
  cardLessButton_MDPI: {
    width: '90%',
    height: 60,
    marginBottom: '2%',
    justifyContent: 'center',
    shadowOpacity: 2,
    shadowRadius: 3,
    borderRadius: 1,
    backgroundColor: '#101d6c'
  },
  moreButton_HDPI: {
    width: '70%',
    height: 60,
    justifyContent: 'center',
    shadowOpacity: 2,
    shadowRadius: 3,
    borderRadius: 1,
    backgroundColor: '#ff6600'
  },
  homescreen: {
    marginTop: 20
  },
  TopsectionAutocompletestyleVRM: {
    width: '75%',
    height: 41,
    borderRadius: 21,
    backgroundColor: '#FFFFFF',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'left',
    paddingHorizontal: widthInPercentage(3.5),
    marginBottom: widthInPercentage(1.4),
  },
  TopsectionAutocompletestyleVRM_XXHDPI: {
    width: '79%',
    height: 41,
    borderRadius: 21,
    backgroundColor: '#FFFFFF',
    paddingHorizontal: widthInPercentage(3.5),
    justifyContent: 'center',
    marginLeft: widthInPercentage(19),
    marginBottom: widthInPercentage(1.4),
  },
  TopsectionAutocompletestyleSearchBar: {
    fontFamily: 'Mulish',
    fontSize: 16
  },
  TopsectionAutocompleteButtonstyleSearchBar: {
    borderBottomWidth: 0.5,
    borderColor: '#dadada',
    display: 'flex',
    flexDirection: 'row',
  },
  TopsectionAutocompleteButtonstyleSearchBar_XXHDPI: {
    borderBottomWidth: 0.5,
    borderColor: '#dadada',
    display: 'flex',
    flexDirection: 'row',
    whiteSpace: 'initial',
    alignItems: 'baseline'
  },
  TopsectionAutocompletemenutextstyleSearchBar: {
    paddingVertical: 15,
    paddingLeft: 20,
    fontFamily: 'Mulish',
    justifyContent: 'center',
    color: '#101d6c',
    alignSelf: 'baseline'
  },
  TopsectionAutocompleteServicetextstyleSearchBar: {
    paddingVertical: 15,
    paddingHorizontal: 1,
    fontFamily: 'Mulish',
    fontSize: 14,
    color: '#101d6c',
    whiteSpace: 'initial'
  },
  nav: {
    position: Platform.OS === 'web' ? 'fixed' : null,
    width: '100%',
    backgroundColor: '#fff',
    zIndex: 99999
  },
  rootStyle: {
    maxWidth: 1300, //changes made here , might have to revert it later
    paddingTop: 0,
    paddingBottom: 0,
    width: '100%',
    marginBottom: 0,
    marginTop: 73
  },
  container: {
    marginTop: 0,
    minHeight: Platform.OS === 'web' ? '100vh' : '100%'
  },
  isblur: {
    flexDirection: 'row',
    backgroundColor: '#808080',
    opacity: 0.1,
    zIndex: 9999999999999999,
    pointerEvents: 'none'
    //commented for mobile need to put seperate style
  },
  isblur_LDPI: {
    flexDirection: 'row',
    backgroundColor: '#808080',
    opacity: 0.1,
    zIndex: 9999999999999999,
    // pointerEvents: 'none' 

  },
  isblur_MDPI: {
    flexDirection: 'row',
    backgroundColor: '#808080',
    opacity: 0.1,
    zIndex: 9999999999999999,
    // pointerEvents: 'none'  
  },
  isblur_HDPI: {
    flexDirection: 'row',
    backgroundColor: '#808080',
    opacity: 0.1,
    zIndex: 9999999999999999,
    // pointerEvents: 'none'    
  },
  isNotblur: {
    flexDirection: 'row'
  },
  isNotbluratm: {
    flexDirection: 'row',
    height: '100%'
  },
  Homescreensplit: {
    marginRight: '1%',
    width: '25%',
    //height: 501,
    backgroundColor: '#e9e9e9',
    marginTop: widthInPercentage(2.5)
  },

  HomescreensplitParams: {
    marginRight: '1%',
    width: '25%',
    //height: 501,
    backgroundColor: '#e9e9e9',
  },
  Homescreensplit_LAPTOP: {
    // width: '30%',
    //height: 501,
    //marginTop: widthInPercentage(5)
  },
  Homescreensplit_XXHDPI: {
    width: '30%',
    marginTop: widthInPercentage(5)
  },
  HomescreensplitParams_XXHDPI: {
    marginTop: widthInPercentage(0)
  },
  HomescreensplitParams_XHDPI: {
    marginTop: widthInPercentage(0)
  },
  Homescreensplit_XHDPI: {
    //backgroundColor:'pink'
    //width: '30%',
    height: 360,
    marginTop: widthInPercentage(4)
  },
  homescreenMobileMargin: {
    // marginTop: 10,
    marginBottom: 10
  },
  homescreenMobileMargin_LDPI: { marginBottom: 0 },
  homescreenMobileMargin_MDPI: { marginBottom: 0 },

  homescreenMobileScrollViewMargin: {
    marginTop: 90,
    zIndex: 5
  },
  homescreenMobileScrollViewMargin_XHDPI: {
    // marginTop: 90,
    height: 385,
    zIndex: 5
  },
  homescreenMobileScrollViewMargin_LDPI: { marginTop: 69 },
  homescreenMobileScrollViewMargin_MDPI: { marginTop: 75 },
  homescreenMobileScrollViewMargin_HDPI: { marginTop: 75 },
  homescreenMobileScrollViewMargin_XXXHDPI: { marginTop: 75 },
  homescreenMobileScrollViewMarginProfile: {
    marginTop: 94,
    zIndex: 5
  },
  homescreenMobileScrollViewMarginheadernone: {
    zIndex: 5
  },
  homescreenMobileScrollViewMarginFirefox: {
    marginTop: 90.5,
    zIndex: 5
  },
  homescreenMobileScrollViewMarginFirefoxheadernone: {
    zIndex: 5
  },
  Homescreenhidemenu: {
    // justifyContent: 'center',
    // alignItems: 'center',
    // backgroundColor: '#fff',
    // width: '75%'
    backgroundColor: '#fff',
    width: '100%'
  },
  HomescreenhidemenuProfile: {
    backgroundColor: '#fcebd6',
    width: '100%',
    height: 543
  },
  Homescreenloadingimage: {
    backgroundColor: 'white',
  },
  Homescreensplit2: {
    // justifyContent: 'center',
    // alignItems: 'center',
    // backgroundColor: '#fff',
    // width: '75%'
    //backgroundColor: '#fcebd6',
    width: '74%',
    minHeight: '86vh',
    //borderRadius: 45,
    marginTop: widthInPercentage(3.5)
    //marginLeft: '1%'
  },
  Homescreensplit2Params: {
    width: '74%',
    minHeight: '86vh',
    //borderRadius: 45,
    marginTop: '1%',
    //marginTop: widthInPercentage(2.5)
  },
  Homescreensplit2atm: {
    backgroundColor: '#fcebd6',
    width: '70%',
    minHeight: '50vh',
    borderRadius: 40,
    marginTop: widthInPercentage(3)
  },
  // Homescreensplit2mob: {
  //   backgroundColor: '#fff',
  //   width: '75%',
  //   minHeight: '86vh'
  // },
  Homescreensplit2_LAPTOP: {
    minHeight: '40vh'
  },
  Homescreensplit2_XXHDPI: {
    minHeight: '40vh',
    width: '68%'
  },
  // Homescreensplit2_XHDPI: {
  //   width: '70%'
  // },
  serviceBoxPadding: {
    padding: 12,
  },
  serviceBoxPadding_LDPI: {
    padding: 10
  },
  serviceBoxPadding_MDPI: {
    padding: 10
  },
  serviceBoxPadding_HDPI: {
    padding: 10
  },
  serviceBoxPadding_XHDPI: {
    padding: 8
  },
  serviceBoxPadding_XXHDPI: {
    padding: 10
  },
  serviceBoxPadding_XXXHDPI: {
    paddingHorizontal: 20,
    paddingVertical: 15
  },

  serviceBox: {
    width: '100%',
    height: Platform.OS === 'web' ? '100%' : null,
    justifyContent: 'center',
    backgroundColor: '#ffb571',
    borderRadius: 5,
    shadowColor: '#000',
    flexDirection: 'column',
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.2,
    shadowRadius: 15,
    padding: 10,
    paddingBottom: 0,
    paddingRight: 0
  },
  serviceBox_LDPI: { flexDirection: 'column', justifyContent: 'flex-start', },
  serviceBox_MDPI: { flexDirection: 'column', justifyContent: 'flex-start', },
  serviceBox_HDPI: { flexDirection: 'column', justifyContent: 'flex-start', },
  serviceBox_XHDPI: { flexDirection: 'column', padding: 4, },
  serviceBox_XXXHDPI: { flexDirection: 'column', },
  serviceBox_XXHDPI: {
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    backgroundColor: '#ffb571',
    shadowOpacity: 0.1,
    shadowRadius: 15,
    padding: 10
  },

  serviceImageView: {
    flex: 1,
    marginVertical: '8%'
  },
  serviceImageView_LDPI: {
    marginVertical: '0%',
    alignItems: 'flex-start',
    padding: 5
  },
  serviceImageView_MDPI: {
    marginVertical: '0%',
    //alignItems: 'flex-start',
    padding: 5
  },
  serviceImageView_HDPI: {
    marginVertical: '0%',
    alignItems: 'center',
    padding: 5
  },
  serviceImageView_XHDPI: {
    marginVertical: '0%',
    alignItems: 'center',
    padding: 2
  },
  serviceImageView_XXHDPI: {
    //marginVertical: '5%',
    justifyContent: 'center',
    alignItems: 'flex-start',
    marginLeft: 5,
    marginRight: 5
  },

  serviceTextView: {
    justifyContent: 'center',
    textAlign: 'center',
    marginVertical: widthInPercentage(2)
  },
  serviceTextView_LAPTOP: { flex: 3, justifyContent: 'center' },
  serviceTextView_XXHDPI: {
    flex: 3,
    justifyContent: 'center',
    textAlign: 'center',
    padding: 3
  },
  serviceTextView_XXXHDPI: {
    flex: 3,
    justifyContent: 'center',
    textAlign: 'center'
  },
  serviceTextView_MDPI: {
    justifyContent: 'flex-start',
    textAlign: 'flex-start',
    marginVertical: widthInPercentage(3)
  },
  circleBox: {
    backgroundColor: '#c5c5c5',
    width: 12,
    margin: 5,
    height: 12,
    borderRadius: 12 / 2
  },
  selectedcircleBox: {
    backgroundColor: '#ef6912',
    width: 12,
    margin: 5,
    height: 12,
    borderRadius: 12 / 2
  },
  itemInvisible: {
    backgroundColor: 'transparent'
  },
  nextView: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'flex-end',
    paddingTop: '1%',
    padding: '1%'
  },
  nextImageView: {
    backgroundColor: '#ef6912',
    borderRadius: 5,
    shadowColor: '#ef6912',
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.2,
    shadowRadius: 15
  },

  preView: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'flex-start',
    paddingTop: '1%',
    padding: '1%'
  },
  prevImageView: {
    backgroundColor: '#ef6912',
    borderRadius: 5,
    shadowColor: '#ef6912',
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.2,
    shadowRadius: 15
  },

  updatedImagestyle: {
    height: 120,
    width: 120
  },
  textHeading: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 35,
    fontWeight: '900',
    fontFamily: 'Mulish',
    marginTop: '5%'
  },
  textHeading_MDPI: {
    fontSize: 30
  },
  textHeading_LDPI: {
    fontSize: 30
  },
  Homescreensplit2backgroundcolorOther: {
    // backgroundColor: '#F0F0F0',
    //backgroundColor: '#fff',
    //backgroundColor: 'blue',
    padding: 30,
    paddingBottom: 0,
    height: Platform.OS === 'web' ? 600 : 550
  },

  Homescreensplit2backgroundcolorOther_XXHDPI: { padding: 15 },
  Homescreensplit2backgroundcolorOther_LDPI: {
    //  backgroundColor: '#F0F0F0',
    padding: 15,
    minHeight: Platform.OS === 'web' ? 520 : 550,
    height: '100%'
  },
  Homescreensplit2backgroundcolorOther_MDPI: {
    //backgroundColor: '#F0F0F0',
    padding: 15,
    minHeight: Platform.OS === 'web' ? 520 : 550,
    height: '100%'
  },
  Homescreensplit2backgroundcolorOther_HDPI: {
    // backgroundColor: '#F0F0F0',
    padding: 15,
    minHeight: Platform.OS === 'web' ? 520 : 550,
    height: '100%'
  },

  Homescreensplit2backgroundcolorProfile: {
    padding: 31,
    paddingBottom: 0,
    height: Platform.OS === 'web' ? 543 : 550,
    justifyContent: 'center'
  },
  Homescreensplit2backgroundcoloratm: {
    paddingTop: 12,
    paddingRight: 25,
    paddingLeft: 16,
    // paddingBottom: 0,
    height: Platform.OS === 'web' ? 300 : 450
  },
  // Homescreensplit2backgroundcolormob: {
  //   padding: 30,
  //   paddingBottom: 0,
  //   height: Platform.OS === 'web' ? 540 : 550,
  //   justifyContent: 'center',
  //   // backgroundColor: 'red',
  // },
  Homescreensplit2backgroundcolorATM: {
    padding: 5,
    paddingBottom: 0,
    height: Platform.OS === 'web' ? 323 : 450
  },
  Homescreensplit2backgroundcolor: {
    padding: 12,
    // paddingBottom: 0,
    //height: Platform.OS === 'web' ? 458 : 550,
    justifyContent: 'center'
  },
  Homescreensplit2backgroundcolor_XXHDPI: { padding: 15 },
  Homescreensplit2backgroundcolor_LDPI: {
    //  backgroundColor: '#F0F0F0',
    ///padding: 15,
    minHeight: Platform.OS === 'web' ? 520 : 550,
    height: '100%',
    width: '100%',
    //marginLeft: '5%',
    //borderRadius: 25,
    backgroundColor: '#fcebd6'
  },
  Homescreensplit2backgroundcolor_MDPI: {
    //backgroundColor: '#F0F0F0',
    //padding: 15,
    minHeight: Platform.OS === 'web' ? 520 : 550,
    height: '100%',
    width: '100%',
    // marginLeft: '5%',
    //borderRadius: 25,
    backgroundColor: '#fcebd6'
  },
  Homescreensplit2backgroundcolor_HDPI: {
    // backgroundColor: '#F0F0F0',
    backgroundColor: '#fcebd6',
    padding: 15,
    minHeight: Platform.OS === 'web' ? 520 : 550,
    height: '100%'
  },



  Homescreensplit2backgroundcolorFireFox: {
    padding: 12,
    // paddingBottom: 0,
    height: Platform.OS === 'web' ? 525 : 550,
    justifyContent: 'center'
  },
  Homescreensplit2backgroundcolorFireFox_XXHDPI: { padding: 15 },
  Homescreensplit2backgroundcolorFireFox_LDPI: {
    //  backgroundColor: '#F0F0F0',
    ///padding: 15,
    minHeight: Platform.OS === 'web' ? 520 : 550,
    height: '100%',
    width: '100%',
    //marginLeft: '5%',
    //borderRadius: 25,
    backgroundColor: '#fcebd6'
  },
  Homescreensplit2backgroundcolorFireFox_MDPI: {
    //backgroundColor: '#F0F0F0',
    //padding: 15,
    minHeight: Platform.OS === 'web' ? 520 : 550,
    height: '100%',
    width: '100%',
    // marginLeft: '5%',
    //borderRadius: 25,
    backgroundColor: '#fcebd6'
  },
  Homescreensplit2backgroundcolorFireFox_HDPI: {
    // backgroundColor: '#F0F0F0',
    backgroundColor: '#fcebd6',
    padding: 15,
    minHeight: Platform.OS === 'web' ? 520 : 550,
    height: '100%'
  },



  cashButtonView: {
    width: '50%',
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: 20,
    paddingTop: 20,
    backgroundColor: '#fff'
  },
  servieNotavailableView: {
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '20%',
    backgroundColor: 'white'
  },
  cardButtonMobView: {
    width: '90%',
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: 20,
    paddingTop: 20,
    backgroundColor: '#fff'
  },
  textHeadingInLayouthidemenu: {
    fontSize: 22,
    paddingBottom: 6,
    fontFamily: 'Mulish',
    color: '#000',
    fontWeight: '500',
    paddingLeft: 10
  },
  textHeadingInLayoutATM: {
    fontSize: 16
  },
  textHeadingInLayout: {
    fontSize: 24,
    fontFamily: 'Mulish',
    color: '#000',
    fontWeight: '500',
    paddingBottom: 10,
    paddingLeft: 10
  },
  textHeadingInLayout_LDPI: {
    fontSize: 16
  },
  textHeadingInLayout_MDPI: {
    fontSize: 16
  },
  textHeadingInLayout_HDPI: {
    fontSize: 20
  },
  textHeadingInLayout_XXHDPI: {
    fontSize: 20
  },
  textHeadingInLayout_XHDPI: {
    fontSize: 20
  },
  textHeadingInLayout_LAPTOP: {
    fontSize: 20
  },
  flatMobView: {
    flex: 2,
    justifyContent: 'center',
    padding: '2%'
  },
  flatMobView_LDPI: { marginTop: 20 },
  flatMobView_MDPI: { marginTop: 20 },
  flatMobView_HDPI: { marginTop: 20 },

  flatListmobView: {
    width: '100%'
  },
  serviceImageStyle: {
    height: 16,
    width: 16,
    padding: 12
  },
  serviceImageStyle_LDPI: { height: 15, width: 15, padding: 15 },
  serviceImageStyle_MDPI: { height: 15, width: 15, padding: 15 },
  serviceImageStyle_HDPI: { height: 15, width: 15, padding: 15 },
  serviceImageStyle_XHDPI: { height: 15, width: 15, padding: 15 },
  serviceImageStyle_XXHDPI: { height: 15, width: 15, padding: 8 },
  serviceImageStyleArrow: {
    height: 16,
    width: 16,
    padding: 12
  },
  serviceImageStyleArrow_LDPI: { height: 8, width: 8, padding: 8 },
  serviceImageStyleArrow_MDPI: { height: 8, width: 8, padding: 8 },
  serviceImageStyleArrow_HDPI: { height: 8, width: 8, padding: 10 },
  serviceImageStyleArrow_XHDPI: { height: 14, width: 14, padding: 8 },
  serviceImageStyleArrow_XXHDPI: { height: 15, width: 15, padding: 8 },
  HomescreenMainView: {
    //backgroundColor: 'red',
    // margin: '0',
    // height: '100%',
    // overflow: 'hidden'
    // height: Platform.OS === 'web' ? '100vh' : '100%',
  },
  HomescreenMainView_XHDPI: {
    //backgroundColor: 'red',
    margin: '0',
    // height: '100%',
    overflow: 'hidden',
    height: Platform.OS === 'web' ? '100vh' : '100%',
  },
  HomescreenMainView_LDPI: {
    // height: Platform.OS === 'web' ? '100vh' : '100%',
    // backgroundColor: '#F0F0F0',
  },
  HomescreenMainView_MDPI: {
    // backgroundColor: '#F0F0F0',
    // height: Platform.OS === 'web' ? '100vh' : '100%',
  },
  loadingImagestyle: {
    width: 80,
    height: 80
  },
  homescreenService:
    { backgroundColor: 'white', borderBottomEndRadius: 4, borderTopLeftRadius: 4 },
  homescreenService_HDPI:
    { backgroundColor: 'white', borderBottomEndRadius: 4, borderTopLeftRadius: 4, },
  modalView: { flexDirection: 'column', backgroundColor: 'white', borderRadius: 10, paddingVertical: widthInPercentage(2), justifyContent: 'center', alignItems: 'center', alignContent: 'center', marginHorizontal: widthInPercentage(25), },
  fatcaModalView: { width:"90%",marginLeft:"10%",marginRight:"5%",flexDirection: 'column', backgroundColor: 'white', borderRadius: 10, paddingVertical: widthInPercentage(2), justifyContent: 'center', alignItems: 'center', alignContent: 'center', marginHorizontal: widthInPercentage(25), },

  modalView_LAPTOP: { flexDirection: 'column', borderRadius: 10, backgroundColor: 'white', paddingVertical: widthInPercentage(2), justifyContent: 'center', alignItems: 'center', alignContent: 'center', marginHorizontal: widthInPercentage(20), paddingLeft: 30 },
  modalView_XXXHDPI: { marginHorizontal: widthInPercentage(10), borderRadius: 10, width: widthInPercentage(60) },
  modalView_XXHDPI: { marginHorizontal: widthInPercentage(10), borderRadius: 10, width: widthInPercentage(65) },
  modalView_LDPI: { marginHorizontal: widthInPercentage(1), borderRadius: 10, width: widthInPercentage(100) },
  modalView_HDPI: { marginHorizontal: widthInPercentage(1), borderRadius: 10, width: widthInPercentage(100) },
  modalView_MDPI: { marginHorizontal: widthInPercentage(1), borderRadius: 10, width: widthInPercentage(100) },
  modalView_XHDPI: { marginHorizontal: widthInPercentage(10), borderRadius: 10, width: widthInPercentage(60) },
  fatcaView:{marginLeft:"5px",padding:"25px"},
  declarText: {    
    fontFamily: 'Mulish', fontSize: 14, justifyContent: 'center', paddingVertical: 2, paddingLeft: 10 ,display:"inline"},
  declarText_LAPTOP: { fontSize: 14, justifyContent: 'center' },
  declarText_XHDPI: { fontSize: 14, justifyContent: 'center' },
  declarText_LDPI: { fontSize: 14, justifyContent: 'center' },
  declarText_MDPI: { fontSize: 14, justifyContent: 'center' },
  declarText_HDPI: { fontSize: 14, justifyContent: 'center' },
  textStyle: {
    color: '#ffffff',
  },
  modaldeclarText: {    
    fontFamily: 'Mulish', fontSize: 14, justifyContent: 'center', paddingVertical: 2, paddingLeft: 10 ,color: "#337ab7"},
  modaldeclarText_LAPTOP: { fontSize: 14, justifyContent: 'center' },
  modaldeclarText_XHDPI: { fontSize: 14, justifyContent: 'center' },
  modaldeclarText_LDPI: { fontSize: 14, justifyContent: 'center' },
  modaldeclarText_MDPI: { fontSize: 14, justifyContent: 'center' },
  modaldeclarText_HDPI: { fontSize: 14, justifyContent: 'center' },
  agreeButton: {
    flex: 1,
    padding: 10,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 5,
    marginHorizontal: '10%',
  },
  agreeButton_MDPI: {
    width:"40%",
    padding: 5,
  },
  agreeButton_LDPI: {
    marginHorizontal: '0%',
    flex: 2,
    padding: 5,
  },
  stepsMessageText: {
    marginVertical: 5,
    fontSize: 10,
    textAlign: "center",
    color: '#616161',
    fontFamily: "Mulish",
    marginLeft: 20,
  },
  stepsMessageText_HDPI: {
    textAlign: "left",
    width: 250
  },
  stepsMessageText_LDPI: {
    textAlign: "left",
    width: 250
  },
  stepsMessageText_MDPI: {
    textAlign: "left",
    width: 250
  },
  // removing inline styles
  serviceBoxStyling: {
    flex: 1,
    backgroundColor: 'transparent',
  },
  serviceBoxStyle: {
    height: '100%',
    borderRadius: 2,
    elevation: Platform.OS === 'web' ? 5 : 2,
    shadowColor: 'grey',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.2,
    borderBottomRightRadius: 6,
    shadowRadius: 15,
    backgroundColor: '#ffb571',
  },
  serviceTextColor: {
    color: '#101d6c'
  },
  HomeScreenView: {
    alignItems: 'flex-end'
  },
  serviceImageArrow: {
    padding: 5
  },
  ModalViewStyle: {
    // width: '100%',
  },
  modalDropdownStyle: {
    paddingHorizontal: widthInPercentage(2),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end'
  },
  fatcamodalDropdownStyle:{
    paddingHorizontal: widthInPercentage(2),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end'
  },
  modalCancel: {
    height: 20,
    width: 20,
    padding: 4
  },
  hyperLinkTextStyle: {
    alignItems: 'center',
    padding: 2,
    justifyContent: 'center',
    textAlign: 'center',
    cursor: 'pointer'
  },
  hyperTextPara: {
    alignItems: 'center',
    padding: 2,
    justifyContent: 'center',
    textAlign: 'center',
  },
  agreeButtonView: {
    flexDirection: 'row',
    marginTop: '5%'
  },
  agreeButtonView_MDPI: {
    flexDirection: 'row',
    margin: '5%'
  },
  textStylePadding: {
    paddingHorizontal: 10
  },
  homeScreenMarginBotton: {
    marginBottom: '10%'
  },
  homeScreenMobileZindex: {
    zIndex: -9
  },
  ProfileserviceTextColor: {
    color: '#101d6c'
  },
  flatMobileView: {
    flexDirection: 'row'
  },
  flatMobileViewStyles: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  viewLessStyle: {
    paddingHorizontal: '22%',
    paddingVertical: '12%',
    borderRadius: 8,
    backgroundColor: '#ef6912',
    background:
      'linear-gradient(to bottom, #f58e21, #ef6812 )',
  },
  whiteLeftArrow: {
    height: 10,
    width: 10,
  },
  spaceView: {
    flex: 1
  },
  rightArrowSectionView: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  rightArrowView: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'flex-end',
  },
  rightArrowSection: {
    paddingHorizontal: '22%',
    paddingVertical: '12%',
    borderRadius: 8,
    backgroundColor: '#ef6912',
    background:
      'linear-gradient(to bottom, #f58e21, #ef6812)',
  },
  whiteRightArrow: {
    height: 10,
    width: 10,
    borderRadius: 5,
  },
  VersionSection: {
    justifyContent: 'center',
    alignItems: 'center'
  },
  versionTextFont: {
    fontSize: 12
  },
  isblurStyle: {
    backgroundColor: '#fcebd6'
  },
  topSectionAutoCompleteView: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center'
  },
  topSectionStyleBar: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  topSectionTextStyle: {
    width: 25,
    height: 25,
    marginLeft: 5
  },
  otherServiceView: {
    background:
      'linear-gradient(to bottom, #f58e21, #ef6812 )',
    paddingVertical: '8%',
    paddingHorizontal: '20%',
  },
  imageLeftArrow: {
    width: 14,
    height: 21
  },
  blurBackground: {
    justifyContent: 'center',
    padding: '2%',
  },
  displayBlurOff: {
    display: 'none'
  },
  displayBlurOn: {
    width: '100%',
    alignItems: 'center',
    paddingTop: '2%',
  },
  serviceBoxFlex: {
    flex: 1
  },
  perPageFlex: {
    flexDirection: 'row'
  },
  blurView: {
    zIndex: -999,
    marginLeft: '1%'
  },
  blurOpactity: {
    zIndex: -9999999,
    opacity: 1
  }
});
